import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "notes" }
const _hoisted_2 = { class: "note" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "note" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "note" }
const _hoisted_7 = { class: "title" }
const _hoisted_8 = { class: "note" }
const _hoisted_9 = { class: "title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('quickStartNotes.fuzzyMatch')) + " : ", 1),
      _createTextVNode(" " + _toDisplayString(_ctx.$t('quickStartNotes.fuzzyMatchDescription')), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('quickStartNotes.exactMatch')) + " : ", 1),
      _createTextVNode(" " + _toDisplayString(_ctx.$t('quickStartNotes.exactMatchDescription')), 1)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('quickStartNotes.translatoinProviders')) + " : ", 1),
      _createTextVNode(" " + _toDisplayString(_ctx.$t('quickStartNotes.translatoinProvidersDescription')), 1)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('quickStartNotes.mergeSegment')) + " : ", 1),
      _createTextVNode(" " + _toDisplayString(_ctx.$t('quickStartNotes.mergeSegmentDescription')), 1)
    ])
  ]))
}